class PlatformFunctionBase {
    constructor() {
        // this.APUIFunction = APUI.Fn;
        // this.APUICoreFunction = APCore.Fn;
        // this.APUI = APUI;
        // this.MISAHelpFn = MISAHelpFn;
    }
    /**
     * Hàm lấy cookie
     * created by pdthien
     * @param {*} key
     */
    getAppLanguage(defaultLanguage = "vi") {
        return null;// this.APUICoreFunction.getAppLanguage(defaultLanguage);
    }
    /**
     * Hàm kiểm tra ngôn ngữ hiện tại có phải tiếng việt
     * created by pdthien
     * @returns
     */
    isViLang() {
        return null;//  this.getAppLanguage("vi") == "vi";
    }
    /**
     * Hàm gắn link hỗ trợ
     * Created by cvcuong1 - 9/7/2021
     */
    showHelp(linkHelp) {
        // this.MISAHelpFn.showHelp(linkHelp);
    }
    /**
     * gọi chống tấn công xss dvquang2
     * @param {*} data
     * @returns
     */
    removeXSS(data) {
        return data;// this.APUICoreFunction.removeXSS(data);
    }

    show403() {
        console.log("403")
    }
}

export default PlatformFunctionBase;